import HttpClient from "./index"
import ApiRoutes, { baseUrl } from "../config/endpoints"
import { Store, getTokenLocal } from "../helper/utils"

export default class UsersAPI extends HttpClient {
  constructor() {
    super(baseUrl)
    this._initializeRequestInterceptor()
  }

  // token = getTokenLocal();

  users = ApiRoutes.Users.AllUsers
  newUser = ApiRoutes.Users.NewUser
  newUserStatus = ApiRoutes.Users.NewUserStatus
  userStatus = ApiRoutes.Users.UserStatus
  userRoles = ApiRoutes.Roles.AllUserRoles
  roleCategories = ApiRoutes.Roles.RoleCategories
  newUserRole = ApiRoutes.Roles.NewRole
  editRole = ApiRoutes.Roles.EditRole
  resendUsersInvitation = ApiRoutes.Users.ResendInvitation
  delRole = ApiRoutes.Roles.DelRole

  _initializeRequestInterceptor = () => {
    this.instance.interceptors.request.use(this._handleRequest)
  }

  _handleRequest = async (axiosConfig: any) => {
    return axiosConfig
  }

  // get all user roles to create new user with different roles
  getAllUserRoles = (token: string) => {
    return this.instance({
      method: this.userRoles.Method,
      url: this.userRoles.EndPoint,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
  }
  getAllRoleCategories = (token: string) => {
    return this.instance({
      method: this.roleCategories.Method,
      url: this.roleCategories.EndPoint,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
  }
  getAllUsers = (token: string) => {
    return this.instance({
      method: this.users.Method,
      url: this.users.EndPoint,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: undefined,
    })
  }

  updateNewUserStatus = (token: string, uid: any) => {
    return this.instance({
      method: this.newUserStatus.Method,
      url: this.newUserStatus.EndPoint(uid),
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: { status: "active" },
    })
  }

  updateUserStatus = (token: string, uid: any, status: any) => {
    return this.instance({
      method: this.userStatus.Method,
      url: this.userStatus.EndPoint(uid),
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: { status: status },
    })
  }

  createNewRole = (
    token: string,
    roleId: string,
    roleDisplayName: string,
    roleDescription: string,
    roleCategory: string,
  ) => {
    return this.instance({
      method: this.newUserRole.Method,
      url: this.newUserRole.EndPoint,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {
        role_id: roleId,
        role_display_name: roleDisplayName,
        role_description: roleDescription,
        role_category: roleCategory,
      },
    })
  }

  updateRole = (
    token: string,
    roleId: string,
    roleDisplayName: string,
    roleDescription: string,
  ) => {
    return this.instance({
      method: this.editRole.Method,
      url: this.editRole.EndPoint(roleId),
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {
        role_display_name: roleDisplayName,
        role_description: roleDescription,
      },
    })
  }

  resendInvitation = (token: string, uid: any) => {
    return this.instance({
      method: this.resendUsersInvitation.Method,
      url: this.resendUsersInvitation.EndPoint(uid),
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
  }

  deleteRole = (token: string, roleId: string) => {
    return this.instance({
      method: this.delRole.Method,
      url: this.delRole.EndPoint(roleId),
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
  }
}
